import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import { AppContext } from 'contexts';
import { HvAlert } from 'components';
import { KEYS } from 'config/constants';
import FloorplanEditor from './components/FloorplanEditor';
import AdminLogin from './components/AdminLogin';

interface Params {
  listingId: string;
}

function FloorplanEditorIndex() {
  const { listingId } = useParams<Params>();

  const appContext = useContext(AppContext);
  const { setListingId, adminUserToken, adminLoginModalOpen } = appContext;
  useEffect(() => {
    setListingId(listingId);
  }, [adminUserToken]);

  return (
    <div>
      {adminUserToken ? <FloorplanEditor /> : <AdminLogin />}
      <HvAlert />
    </div>
  );
}

export default FloorplanEditorIndex;
